
import { Team } from '@brg/api';
import React, { createContext, useContext } from 'react';

interface IChannelsContext {
  channels: Team<"Global">[] | undefined;
  activeChannel: Team<'Global'> | undefined;
  loading: boolean;
  error: string | null;
  refetch: () => void;
  reset: () => void;
}

const INITIAL_CONTEXT = {
  channels: undefined,
  activeChannel: undefined,
  loading: false,
  error: '',
  refetch: () => null,
  reset: () => null
}

const ChannelsContext = createContext<IChannelsContext>(INITIAL_CONTEXT);

export const useChannelsContext = () => {
  return useContext(ChannelsContext);
};

export default ChannelsContext
import { Team } from '@brg/api';
import React, { createContext, useContext } from 'react';

interface IChannelsContext {
  channels: Team<"Global">[] | undefined;
  activeChannel: Team<'Global'> | undefined;
  loading: boolean;
  error: string | null;
  refetch: () => void;
  reset: () => void;
}

const INITIAL_CONTEXT = {
  channels: undefined,
  activeChannel: undefined,
  loading: false,
  error: '',
  refetch: () => null,
  reset: () => null
}

const ChannelsContext = createContext<IChannelsContext>(INITIAL_CONTEXT);

export const useChannelsContext = () => {
  return useContext(ChannelsContext);
};

export default ChannelsContext